exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cardx .card-body .elist:first-child {\n  padding-top: 0; }\n\n.cardx .card-body .elist:last-child {\n  border-bottom: 0;\n  padding-bottom: 0; }\n\n.elist {\n  padding-top: 15px;\n  padding-bottom: 15px;\n  border-bottom: 1px solid #f8f8f8; }\n\n.elist img {\n  height: 50px;\n  width: 50px;\n  display: block;\n  border-radius: 4px;\n  border: 2px solid rgba(238, 238, 238, 0.4); }\n\n.elist h5 {\n  line-height: 1;\n  font-size: 14px;\n  text-transform: capitalize; }\n\n.elist p {\n  font-size: 14px;\n  color: #999;\n  font-style: italic;\n  line-height: 1; }\n\n.elist span {\n  font-size: 14px;\n  color: #999;\n  margin: 5px 0 0 0;\n  display: block; }\n\n.yellow-bg {\n  background-color: lavenderblush; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/overview/branch-wise-attendance/branch-wise-attendance.component.scss
// module id = ../../../../../src/app/hrms/overview/branch-wise-attendance/branch-wise-attendance.component.scss
// module chunks = main